'use strict'

{millisRemaining, timeRemaining} = require '../../groupon-deal-timer/common/helpers'
{JUICE_PROGRAM_ID, DESKTOP_FF_NAME, TIMER_ADJUST_MINUTES} = require './constants'


setAdjustedJuiceTime = (deal, attributes, featureFlags) ->
  return unless isJuiceProgramEnabled({attributes, featureFlags})

  if isJuicePricingOption deal?.displayOption
    endAt = deal.displayOption?.pricingMetadata?.offerEndsAt
    endAtDate = new Date endAt
    deal.displayOption?.pricingMetadata?.offerEndsAt = new Date(endAtDate - TIMER_ADJUST_MINUTES * 60 * 1000).toISOString()

  if isInJuiceGracePeriod deal?.displayOption
    deal.displayOption.price = deal.displayOption.regularPrice
    deal.displayOption.discountPercent = Math.round((deal.displayOption.value.amount - deal.displayOption.regularPrice.amount) / deal.displayOption.value.amount * 100)

isInJuiceGracePeriod = (dealOption) ->
  return unless dealOption?.pricingMetadata?.programId is JUICE_PROGRAM_ID
  {offerBeginsAt, offerEndsAt} = dealOption.pricingMetadata
  return unless offerBeginsAt and offerEndsAt
  now = new Date()
  endDate = new Date offerEndsAt if offerEndsAt?
  endDate <= now

isJuicePricingOption = (dealOption) ->
  return unless dealOption?.pricingMetadata?.programId is JUICE_PROGRAM_ID
  {offerBeginsAt, offerEndsAt} = dealOption.pricingMetadata
  return unless offerBeginsAt and offerEndsAt
  now = new Date()
  startDate = new Date offerBeginsAt if offerBeginsAt?
  endDate = new Date offerEndsAt if offerEndsAt?
  startDate <= now <= endDate

isJuiceProgramEnabled = ({attributes, featureFlags}) ->
  return unless attributes and featureFlags
  {touchRequest} = attributes
  not touchRequest and featureFlags.enabled DESKTOP_FF_NAME

progressComplete = (startDate, endDate) ->
  return unless startDate and endDate
  fullTime = endDate - startDate
  return unless fullTime > 0
  msLeft = millisRemaining endDate
  Number ((fullTime - msLeft) / fullTime).toFixed 2

clockTimeLeft = (endDate) ->
  return unless endDate
  msLeft = millisRemaining endDate
  return unless msLeft > 0
  if remainedTime = timeRemaining msLeft
    formatJuiceTimer remainedTime

textTimeLeft = (endDate) ->
  return unless endDate
  msLeft = millisRemaining endDate
  return unless msLeft > 0
  if remainedTime = timeRemaining msLeft
    formatTextTimer remainedTime

formatJuiceTimer = (remainedTime) ->
  {minutes, seconds} = remainedTime
  seconds = "0#{seconds}" if seconds < 10
  "#{minutes}:#{seconds}"

formatTextTimer = (remainedTime) ->
  {minutes, seconds} = remainedTime
  "#{minutes}m #{seconds}s"

module.exports = {
  textTimeLeft,
  clockTimeLeft,
  formatJuiceTimer,
  formatTextTimer
  isInJuiceGracePeriod,
  isJuicePricingOption,
  isJuiceProgramEnabled,
  progressComplete,
  setAdjustedJuiceTime
}
